import { bowtieWebThemeOptions, bowtieWebThemeOptionsZh } from '@bowtie-ins/bowkit';
import { zhHK } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
const toLightOptions = bowkitOptions => {
  var _colorSchemes$light;
  const {
    colorSchemes,
    ...options
  } = bowkitOptions;
  return {
    ...options,
    colorSchemes: {
      light: (_colorSchemes$light = colorSchemes === null || colorSchemes === void 0 ? void 0 : colorSchemes.light) !== null && _colorSchemes$light !== void 0 ? _colorSchemes$light : true
    }
  };
};
export const bowtieThemeOptions = toLightOptions(bowtieWebThemeOptions);
const bowtieCjkThemeOptions = toLightOptions(bowtieWebThemeOptionsZh);
export const bowtieTheme = createTheme(bowtieThemeOptions);
export const bowtieCjkTheme = createTheme(bowtieCjkThemeOptions, zhHK);
export const createBrandTheme = ({
  primary,
  secondary,
  fontFamily,
  displayFontFamily = fontFamily
}, isCjk) => {
  const baseOptions = isCjk ? bowtieCjkThemeOptions : bowtieThemeOptions;
  const {
    colorSchemes,
    typography: baseTypography
  } = baseOptions;
  const lightScheme = typeof (colorSchemes === null || colorSchemes === void 0 ? void 0 : colorSchemes.light) === 'object' ? colorSchemes.light : {};
  const typography = typeof baseTypography === 'object' ? baseTypography : {};
  const display = displayFontFamily ? {
    fontFamily: displayFontFamily
  } : undefined;
  const brandOptions = {
    ...baseOptions,
    colorSchemes: {
      light: {
        ...lightScheme,
        palette: {
          ...lightScheme.palette,
          ...(primary ? {
            primary: {
              main: primary
            }
          } : undefined),
          ...(secondary ? {
            secondary: {
              main: secondary
            }
          } : undefined)
        }
      }
    },
    typography: {
      ...typography,
      ...(fontFamily ? {
        fontFamily
      } : undefined),
      h1: {
        ...typography.h1,
        ...display
      },
      h2: {
        ...typography.h2,
        ...display
      },
      h3: {
        ...typography.h3,
        ...display
      }
    }
  };
  return isCjk ? createTheme(brandOptions, zhHK) : createTheme(brandOptions);
};
export default bowtieTheme;